import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const mapList = async (token) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/map`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error; 
  }
};